<script setup lang="ts">
defineProps<{
  knowledgeBase: PublicKBKnowledgeBase
}>()

const year = computed(() => new Date().getFullYear())
</script>

<template>
  <footer class="bg-gray-900 pt-4 text-white">
    <Container>
      <div class="flex items-center justify-between">
        <div v-if="knowledgeBase.copyright" class="font-light text-gray-400">
          © {{ year }} {{ knowledgeBase.copyright }}
        </div>

        <div class="flex items-center gap-4">
          <template v-for="(link, _index) in knowledgeBase.footer_links">
            <a v-if="link.title && link.url" :href="link.url" target="_blank" rel="noopener noreferrer">{{
              link.title
            }}</a>
          </template>
        </div>
      </div>
    </Container>
  </footer>
</template>

<i18n lang="yaml"></i18n>
